export const languages = {
    en: {
        access_token: "en_snail_access_token",
        token: "en_snail_token",
        bl: "en_snail",
        language: "en-us",
        nologin: "Snail",
        sdkObj: {
            game_id: 64,
            game_sign: "snail.2ndSpecial.eu",
            game_version: "v1.0.0",
            spec_lang: "en-us",
            google_client_id: "4750573344-r99j5sj2godq5ub9sd6pq9s7d3abuikb.apps.googleusercontent.com",
            apple_client_id: "com.qcplay.snail.ios.na.sign-in-with-apple",
            facebook_client_id: "467595308549623",
            platform: "qcna"
        },
        find_team_btn: require("@/assets/images/thirdAnniversary/find_team_icon.png"),
        rule: require("@/assets/images/thirdAnniversary/popup/team-rule.png"),
        isActiveAppointment: require("@/assets/images/thirdAnniversary/pre-team_formation_tips.png"),
        isActiveAppointmentPre: require("@/assets/images/thirdAnniversary/team_time_tips.png"),
        discord: "https://discord.com/channels/1036712913727143998/1523927213379162192",
        download: "https://supersnailw2a.onelink.me/I93H/3znq",
        rechargeUrl: "https://pay.qcplay.com/pay",
        teamShareLinkText: "Join my team for the Wonderland Treasure Hunt! Collect Wonderland Keys and grab awesome rewards together!",
        teamShareTitle: "Super Snail, 3rd Anniversary Team-Up Is Live!",
        teamShareDesc: "Join my team for the Wonderland Treasure Hunt! Collect Wonderland Keys and grab awesome rewards together!",
        eggDesc: "Happy 3rd Anniversary",
        copy_success: "Copy Successful",
        copy_error: "Copy Unsuccessful",
        onMorePoints: "The event hasn't started yet. Stay tuned!",
        toRecharge: "The event hasn't started yet. Stay tuned!",
        onKickOutSgin: "Removed from the team",
        joinSuccess: "Team joined",
        slogan: "Memes for you and me",
        title: "Super Snail",
        pageTitle: "Super Snail",
        self: "me",
        power: " Point",
        team: "Team Number:",
        team_code: "Team Points",
        team_tips: "*Purchases begin to count from Dec 19, 05:00 (UTC-8)",
        Account: "Account status:",
        Contribution: "Contribution:",
        Cooldown: "Cooldown",
        computational: "",
        Cumulative: "Current Points",
        is_has_out_news: "You have been kicked out of the team",
        share_warp: require("@/assets/images/thirdAnniversary/popup/team-share-popup.png"),
        timeBalance: function addHours(dateStr, hours = -16) {
            const date = new Date(dateStr.replace(/-/g, "/"));
            date.setHours(date.getHours() + hours);
            const pad = n => (n < 10 ? "0" + n : n);
            return (
                `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
          date.getDate()
        )} ` +
                `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
            );
        },
        activitiesCardsen: [{
                label: "3rd Anniversary Deals",
                id: 1,
                image: require("@/assets/images/thirdAnniversary/3/banner_1.png"),
                url: "https://pay.qcplay.com/pay?officialSettingId=3",
                time: "2026-7-31 05:00:00"
            },
            {
                label: "Discord Check-in Rewards",
                id: 2,
                image: require("@/assets/images/thirdAnniversary/3/banner_2.png"),
                url: "https://discord.com/channels/1036712913727143998/1364121623283896360",
                time: "2026-8-1 00:00:00"
            },
            {
                label: "Anniversary Lucky Koi",
                id: 3,
                image: require("@/assets/images/thirdAnniversary/3/banner_3.png"),
                // url: "https://pay.qcplay.com/anniverlottery",
                time: "2026-8-7 05:00:00"
            }
        ],
        packageList: [
            600,
            1200,
            1800,
            2300,
            3000,
            4500,
            7500,
            11000,
            15000,
            23000,
            30000,
            45000,
            60000,
            75000,
            110000,
            150000,
            220000,
            290000,
            360000,
            430000,
            510000,
            590000,
            670000,
            750000,
            900000,
            1050000,
            1200000,
            1350000
        ].map(score => ({
            score,
            status: "locked"
        }))
    }
};


// WEBPACK FOOTER //
// ./src/pages/thirdAnniversary/language.js